import React from 'react';
import SMFormValidationMessage from './SMFormValidationMessage';
import SMFormFieldBaseView from 'components/dashboard/form/SMFormFieldBaseView';

class SMFormCheckBoxWithError extends SMFormFieldBaseView {
  
  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }
  
  didChangeValue(e) {
    if(this.props.delegate && typeof this.props.delegate.checkBoxDidChangeValue === 'function'){
      this.props.delegate.checkBoxDidChangeValue(e);
    }
  }
  
  render() {
    
    let items = [];
    for (var i = 0; i < this.props.items.length; i++) {
      const id = this.props.name + "[" + i + "]";
      if (this.props.postHiddenData == true) {
        items.push(
          <input type='hidden' key={id+'-hidden'} name={this.props.name} value='0' />
        );
      }
      items.push(
        <input type="checkbox" id={id} key={id} name={this.props.name} value={this.props.items[i].value} defaultChecked={this.props.items[i].checked} onChange={this.didChangeValue.bind(this)} />
      );
      items.push(
        <label htmlFor={id} key={id+'-label'} className={'form-checkbox ' + this.props.options.className}>{this.props.items[i].label}</label>
      );
    }
    
    return (
      <div className="form-box">
        {items}
        <SMFormValidationMessage name={this.props.name} errorText={this.props.errorText} />
      </div>
    );
  }
}

SMFormCheckBoxWithError.defaultProps = {
  items: [],
  options: {
    className: ""
  }, 
  postHiddenData: true
};
export default SMFormCheckBoxWithError;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMFormCheckBoxWithError.jsx